import {
    Model
} from '@/lib/BaseModel';
import fieldSpec from '@/models/commonFieldsSchema';


var schema = {

    fName: {
        label: fieldSpec.fName.label,
        truncate: fieldSpec.fName.maxLength,
        validation: {
            required: 'Must be filled in.'
        }
    },

    lName: {
        label: fieldSpec.lName.label,
        truncate: fieldSpec.lName.maxLength,
        validation: {
            required: 'Must be filled in.'
        }
    },

    email: {
        label: fieldSpec.email.label,
        truncate: fieldSpec.email.maxLength,
        validation: {
            email: 'Must be a properly formatted email address.',
            required: 'Must be filled in.'
        }
    },

    password: {
        label: fieldSpec.password.label,
        truncate: fieldSpec.password.maxLength,
        validation: {
            required: 'Must be filled in.',
            min: [6, 'Must be at least 6 characters.']
        },
    },

    confirmPassword: {
        label: 'Confirm Password',
        truncate: fieldSpec.password.maxLength,
        validation: {
            required: 'Must be filled in.',
            min: [6, 'Must be at least 6 characters.'],
            matchProp: ['password', 'Must match the Password entered above.']
        },
    },

    enabled: {
        label: 'Account Enabled',
        default: true
    },

    agreeTermsPrivacy: {
        label: 'Agree To Terms of Service and Privacy Policy',
        default: false,
        validation: {
            type: 'boolean'
        }
    },
    agreeCookies: {
        label: 'Agree to Cookies Usage',
        default: false,
        validation: {
            type: 'boolean'
        }
    },
    agreeEmailNotify: {
        label: 'Agree to Receive Email Notifications',
        default: false,
        validation: {
            type: 'boolean'
        }
    }

}

var SignUp = Model.make('Signup', schema);

export {
    SignUp
};